import { useState } from "react";
import { Link } from "react-router-dom";
import { Waveform, EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import axios from "axios";

import { API } from "@/lib/apiBase";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error("Please enter your email"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success("If an account exists, a reset link has been sent.");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "#0A0A0C" }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Waveform size={36} weight="bold" style={{ color: "#F59E0B" }} />
            <h1 className="text-3xl font-light tracking-tight text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>Daremusics</h1>
          </div>
          <p className="text-base" style={{ color: "#A1A1AA", fontFamily: "'Manrope', sans-serif" }}>Reset your password</p>
        </div>

        <div className="bg-[#141417] border border-white/5 rounded-2xl p-6 md:p-8">
          {sent ? (
            <div className="text-center py-4">
              <div className="w-16 h-16 rounded-full bg-[#10B981]/10 flex items-center justify-center mx-auto mb-4">
                <EnvelopeSimple size={32} weight="bold" style={{ color: "#10B981" }} />
              </div>
              <h3 className="text-xl text-white font-medium mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>Check your email</h3>
              <p className="text-sm mb-6" style={{ color: "#A1A1AA", fontFamily: "'Manrope', sans-serif" }}>
                If an account with <strong className="text-white">{email}</strong> exists, we've sent a password reset link. Check your inbox (and spam folder).
              </p>
              <Link to="/login" className="bg-[#F59E0B] text-black font-semibold rounded-full px-8 py-3 hover:bg-[#D97706] transition-all inline-block" style={{ fontFamily: "'Manrope', sans-serif" }}>
                Back to Login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <p className="text-sm" style={{ color: "#A1A1AA", fontFamily: "'Manrope', sans-serif" }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>
              <div>
                <label className="text-xs uppercase tracking-[0.2em] font-bold block mb-2" style={{ color: "#F59E0B" }}>Email</label>
                <div className="bg-[#0A0A0C] border border-white/10 rounded-xl focus-within:border-[#F59E0B] transition-colors flex items-center gap-3 px-4">
                  <EnvelopeSimple size={18} style={{ color: "#A1A1AA" }} />
                  <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="w-full bg-transparent py-3 text-white placeholder:text-gray-500 outline-none" style={{ fontFamily: "'Manrope', sans-serif" }} required />
                </div>
              </div>
              <button data-testid="forgot-submit-btn" type="submit" disabled={loading} className="bg-[#F59E0B] text-black font-semibold rounded-full px-8 py-3 hover:bg-[#D97706] transition-all disabled:opacity-50 w-full flex items-center justify-center gap-2" style={{ fontFamily: "'Manrope', sans-serif" }}>
                {loading ? <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" /> : null}
                Send Reset Link
              </button>
              <p className="text-center text-sm" style={{ color: "#A1A1AA" }}>
                <Link to="/login" className="hover:text-white transition-colors flex items-center justify-center gap-1" style={{ color: "#F59E0B" }}>
                  <ArrowLeft size={14} /> Back to Login
                </Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
